import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ArbetsorderVirkesorderWarningComponent } from "./arbetsorder-virkesorder-warning/arbetsorder-virkesorder-warning.component";
import { AvslutaVirkesorderButtonComponent } from "./avsluta-virkesorder-button/avsluta-virkesorder-button.component";

@NgModule({
    imports: [
        RaskCommonModule,
        ArbetsorderVirkesorderWarningComponent,
        AvslutaVirkesorderButtonComponent
    ],
    providers: [],
    exports: [
        AvslutaVirkesorderButtonComponent,
        ArbetsorderVirkesorderWarningComponent
    ]
})
export class ArbetsorderVirkesorderModule { }
